import toPercentString from './toPercentString';
import { LayoutPositionDetails } from '../interfaces/LayoutPositionDetails';

export default function convertLayoutPositionToStyles(
    layoutPosition: LayoutPositionDetails
): React.CSSProperties {
    return {
        top: toPercentString(layoutPosition.top),
        left: toPercentString(layoutPosition.left),
        right: toPercentString(layoutPosition.right),
        bottom: toPercentString(1 - (layoutPosition.top + layoutPosition.height)),
    };
}
